import { useGridFilter } from "ag-grid-react";
import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle, useCallback } from "react";
import { Button, Form, FormLabel } from "react-bootstrap";
export const CustomStateFilter = (props) => 
{
    const {model, onModelChange, getValue, colDef} = props;
    const filterOptions = colDef.filterParams.filterOptions;
    
    const valueChanged = useCallback( event => {
        const newValue = event.target.value;
        
        onModelChange(newValue == '' ? null : {filter: newValue, type: ':'});
    })

    const splitValue = (value) => {
        return value.match(/[A-Z]+(?![a-z])|[A-Z]?[a-z]+|\d+/g).join(' ');
    }
    
    const doesFilterPass = useCallback( params => {
        return true;
    })
    return <div className="state-filter">
        <Form>
            <Form.Group>
                <Form.Select size="sm" value={model?.filter ?? ''} onChange={valueChanged}>
                    <option value="">(Select All)</option>
                    {
                        filterOptions.map((option) => (
                            <option key={option} value={option}>{splitValue(option)}</option>
                        ))
                    }
                </Form.Select>
            </Form.Group>
            <div className="d-flex justify-content-end mt-2 mb-2">
                <Button className="ag-button ag-standard-button ag-filter-apply-panel-button" value="" size="sm" onClick={valueChanged}>Reset</Button>
            </div>
        </Form>
    </div>
}
